module.exports = __webpack_public_path__ + "passport/img/nucarf.1002521b.png";